// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2262":"reactPlayerHls","2723":"reactPlayerMux","5836":"body-body"}[chunkId] || chunkId) + "." + {"2262":"e6dc7c957ff4d8c9a71d","2473":"04373fc219fa73d35559","2723":"d2e4c28f03048a77f028","5836":"e29edd5cfde4d41ff87a"}[chunkId] + ".bundle.js";
};